export default "__VITE_ASSET__cewUe2mE__"